export default __webpack_public_path__ + "static/logo-long-gray-0d026d1c55d0c009d88e3064c10fd7f0.png";